import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Services from './pages/Services';
import Home from './pages/Home';
import Contact from './components/Contact';
import Footer from './components/Footer';
import About from './pages/About';
import Locations from './pages/Locations';
import HeaderMenu from './components/HeaderMenu';
import ModalProvider from './components/modal_refactor/ModalProvider';
import QuoteForm from './components/modal_refactor/QuoteForm';
import Modal from './components/modal_refactor/Modal';

const App = () => (
  <div className="App min-h-screen flex flex-col">
    <HeaderMenu />
    <ModalProvider>
      <Routes>
        <Route exact path="/"
          element={<Home />}
        />
        <Route path="/services/:slug" element={<Services />} />              
        <Route path="/about" element={<About />} />                 
        <Route path="/locations" element={<Locations />} />
      </Routes>
      <Modal>
        <Modal.Header>
          <div>Request A Quote</div>
        </Modal.Header>
        <Modal.Body className="2xl:mb-8">
          <QuoteForm />
        </Modal.Body>
      </Modal>
    </ModalProvider>
    <Contact />
    <Footer />
  </div>
);

export default App;
